import React, { useContext } from "react";
import { Table } from "antd";
import { useResizableColumns } from "components/ResizableColumns";
import { ZoomContext } from "components/ZoomPanel";

const SCROLLBAR_WIDTH = 17;

const fitColumns = (columns, available) => {
  const total = columns.reduce(
    (sum, c) => sum + (typeof c.width === "number" ? c.width : 0),
    0,
  );
  if (!total || available <= 0) return columns;
  const scale = (available - SCROLLBAR_WIDTH) / total;
  return columns.map((c) =>
    typeof c.width === "number"
      ? { ...c, width: Math.floor(c.width * scale) }
      : c,
  );
};

const ResizableTable = React.forwardRef(
  ({ columns, components, scroll, ...rest }, ref) => {
    const { zoom, width } = useContext(ZoomContext);
    const enabled = Boolean(columns) && scroll?.x !== undefined;
    const fit = enabled && zoom && width > 0;
    const resizable = useResizableColumns(
      fit ? fitColumns(columns, width) : columns || [],
      { resetKey: fit },
    );

    return (
      <Table
        ref={ref}
        scroll={scroll}
        columns={enabled ? resizable.columns : columns}
        components={
          enabled
            ? {
                ...resizable.components,
                ...components,
                header: {
                  ...resizable.components.header,
                  ...components?.header,
                },
              }
            : components
        }
        {...rest}
      />
    );
  },
);

ResizableTable.Summary = Table.Summary;
ResizableTable.Column = Table.Column;
ResizableTable.ColumnGroup = Table.ColumnGroup;
ResizableTable.SELECTION_COLUMN = Table.SELECTION_COLUMN;
ResizableTable.EXPAND_COLUMN = Table.EXPAND_COLUMN;
ResizableTable.SELECTION_ALL = Table.SELECTION_ALL;
ResizableTable.SELECTION_INVERT = Table.SELECTION_INVERT;
ResizableTable.SELECTION_NONE = Table.SELECTION_NONE;

export default ResizableTable;
